import type { EditableFeatureFlags, SettingsTab } from '@/types/settings.types';

/** Left-hand nav. The prototype lists seven; these four are the ones backed by real behaviour. */
export const SETTINGS_NAV: ReadonlyArray<{ key: SettingsTab; label: string }> = [
  { key: 'fees', label: '💰 Platform Fees' },
  { key: 'flags', label: '⚙️ Feature Toggles' },
  { key: 'coins', label: '🪙 Coin Rules' },
  { key: 'admins', label: '👥 Admin Roles' },
];

/**
 * The three switches that gate real server behaviour.
 *
 * The prototype also showed KYC Verification, Campus Leaderboard and Public Analytics. Those are
 * omitted because nothing in Shoutt reads them — KYC is hardcoded to auto-approve, and neither
 * a leaderboard nor a public-stats screen exists. A switch that does nothing is worse than none.
 */
export const FEATURE_TOGGLES: ReadonlyArray<{
  key: keyof EditableFeatureFlags;
  name: string;
  description: string;
}> = [
  {
    key: 'aiSpamDetection',
    name: '🤖 AI Spam Detection',
    description: 'Scan new shoutts and listings with Claude and flag policy violations',
  },
  {
    key: 'coinRewards',
    name: '🪙 Coin Rewards',
    description: 'Award coins for referrals, reviews and activity. Spending stays enabled',
  },
  {
    key: 'inAppChat',
    name: '💬 In-app Chat',
    description: 'Let students start conversations and send messages. Existing threads stay readable',
  },
];

/** Display order and copy for the read-only coin economy. */
export const COIN_RULE_ROWS: ReadonlyArray<{ key: string; label: string; unit?: string }> = [
  { key: 'completeProfile', label: 'Complete profile' },
  { key: 'firstListing', label: 'First listing' },
  { key: 'firstLenderRental', label: 'First rental as lender' },
  { key: 'borrowerRental', label: 'Rental as borrower' },
  { key: 'review', label: 'Leave a review' },
  { key: 'firstFiveStarReview', label: 'First 5-star review received' },
  { key: 'firstShoutt', label: 'First shoutt posted' },
  { key: 'weeklyActive', label: 'Weekly active user' },
  { key: 'referral', label: 'Verified referral' },
  { key: 'milestoneRental', label: 'Rental milestone (10 / 25 / 50)' },
  { key: 'urgentTag', label: 'Mark a shoutt urgent', unit: 'spend' },
  { key: 'urgentDurationHours', label: 'Urgent duration', unit: 'hours' },
  { key: 'feeDiscount', label: 'Redeem a fee discount', unit: 'spend' },
  { key: 'feeDiscountPct', label: 'Fee discount granted', unit: '%' },
];
